export enum LinkType {
    Other = 0,
    Facebook = 1,
    Twitter = 2,
    Instagram = 3,
    YouTube = 4,
    Pinterest = 5,
    LinkedIn = 6,
    WhatsApp = 7,
    MyWebSite = 8,
    MyOnlineShop = 9,
    TikTok = 10,
    Telegram = 11
}

export class Link {
    public title?: string;
    public url?: string;
    public type?: LinkType;

    get name(): string {
        return LinkType[this.type!];
    }

    get isWhatsApp(): boolean {
        return this.type! === LinkType.WhatsApp;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): Link {
        const link: Link = new Link();

        link.title = this.title;
        link.url = this.url;
        link.type = this.type;

        return link;
    }
}
